export default function SimpleLoader():JSX.Element{
    return(
        <div className="spinner-container">
            <div className="spinner">
            </div>
        </div>
    )
}